<!-- Décor fond vague -->
<div class="login-background">
  <img src="assets/wavehome.png" alt="Décor vague" class="login-decor" />
</div>

<div class="login-content">
  <div class="login-container">
    <h2 class="login-title">Connexion à votre espace</h2>
    <form class="login-form" (submit)="onLogin($event)">
      <!-- Message succès/erreur -->
      <div *ngIf="successMessage" class="login-success">{{ successMessage }}</div>
      <div *ngIf="errorMessage" class="login-error">{{ errorMessage }}</div>
      <!-- Email -->
      <div class="form-group">
        <label for="email">E-mail*</label>
        <input
          type="email"
          id="email"
          name="email"
          autocomplete="username"
          required
          autofocus
          [(ngModel)]="loginForm.email"
        />
      </div>
      <!-- Mot de passe -->
      <div class="form-group">
        <label for="password">Mot de passe*</label>
        <input
          type="password"
          id="password"
          name="password"
          autocomplete="current-password"
          required
          [(ngModel)]="loginForm.password"
        />
      </div>
      <button type="submit" class="login-submit">Se connecter</button>
      <div class="login-extra">
        <a href="#" class="login-link">Mot de passe oublié&nbsp;?</a>
      </div>
    </form>
  </div>
</div>
